import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';
import {listResources} from '../utils/utilsResource';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';


class ListResources extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Resources : null
        };


        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    listResources(
        this.dsd,
        filters,
        (data) => {
            this.setState({
                Resources: data,
                renderState: 'loaded'
            });
            
            // Call parent's onLoad callback if provided
            if (this.state.onLoad){
                this.state.onLoad(data.length);
            }
        },
        (error) => {
            this.setState({
                renderState: 'failed',
                errorMessage: error.message || 'Failed to load resources'
            });
        }
    );
}

setup(){

    let StateChange = {
        renderState: 'loading',
        columns: {
            owner:true,
            status:true,
        },
        onLoad: null
    };

    let filters = getParam('filters', this.props);

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.loadData(filters);


   this.setState(StateChange);
        
}



    included(Resource) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }


        if (this.state.renderState === 'loaded') {

            let arrResources = this.state.Resources;
            if (isArray(arrResources)){
                if (arrResources.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrResources.map(
                                    (Resource, pos) => 
                                    {
                                        if (this.included(Resource)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                

                                            let modelResource = null;
                                            if ("type" in Resource){
                                                if (Resource.type in this.dsd.model.resources){
                                                    modelResource = this.dsd.model.resources[Resource.type];
                                                }
                                            }
                                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/resource/" + Resource.id} > {Resource.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {Resource.Owner &&
                                                                    Resource.Owner.organisation}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.status &&
                                                            <PD.Td>
                                                                {Resource.status}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            {modelResource &&
                                                                modelResource.label}
                                                        </PD.Td>

                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Resource.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }

        }
        return <div />;

    };    
};
        
export default function ListResources_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListResources {...props} navigation={navigation} location={location} params={params} />;
  }
